import { ManageBreadcrumbNavigationUseCase } from '@/application/navigation';
import { ZustandNavigationRepository } from '@/infra/repositories/zustandNavigation.repository';
import { useAppStore } from '@/shared/stores';

/**
 * Container de inyección de dependencias para navegación
 * Implementa DIP: Las dependencias se inyectan desde el exterior
 */
class NavigationContainer {
  private manageBreadcrumbNavigationUseCase: ManageBreadcrumbNavigationUseCase | null =
    null;

  /**
   * Obtiene la instancia del use case de navegación
   */
  getManageBreadcrumbNavigationUseCase(): ManageBreadcrumbNavigationUseCase {
    if (!this.manageBreadcrumbNavigationUseCase) {
      // Crear repositorio con dependencias del store
      const navigationRepository = new ZustandNavigationRepository(
        () => useAppStore.getState().getNavigationState(),
        (updateFn) => {
          const currentNavigation = useAppStore.getState().getNavigationState();
          const updatedNavigation = updateFn(currentNavigation);
          useAppStore.setState({ navigation: updatedNavigation });
        },
      );

      // Inyectar dependencias al use case
      this.manageBreadcrumbNavigationUseCase =
        new ManageBreadcrumbNavigationUseCase(navigationRepository);
    }

    return this.manageBreadcrumbNavigationUseCase;
  }
}

// Exportar instancia singleton
export const navigationContainer = new NavigationContainer();
